var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[(_vm.$store.state.debug)?_c('div',{ref:"debug",staticClass:"debug"}):_vm._e(),_c('canvas',{ref:"canvas",attrs:{"width":_vm.size.width,"height":_vm.size.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }